function BaseController(){
	this.className			= "BaseController";
	this.glob				= "/**";
	this.priority			= 10000;
	this.debug				= false;
};
BaseController.inheritsFrom( StandardController );
BaseController.prototype.swapMain = function(onComplete){

	// setting up aviator stage for the first time
	if(!this.isSetup){

		this.$body 				= $("body");
		this.$scrollElement		= $("body, html");	// what to scroll when navigating with aviator
		this.$jsBody			= this.$body.find(".js-body");

		jcache.setImagesSrcWait(this.$jsBody);

		this.$loadBar = $("body").append("<div class='loadbar' style='width:0px;height:5px;background-color:#FF0098;box-shadow: 0px 4px 8px #FF0098;position:fixed;top:0;left:0;z-index:100'></div>").parent().find(".loadbar");

		this.loader = new Loader();
		this.loader.onStart = (e) => {
			this.$loadBar.stop().css("opacity",1);
		}
		this.loader.onUpdate = (e) => {
			var p = e.percent;
			this.$loadBar.css({width:p+"vw"});
		}
		this.loader.onFinished = (e) => {
			this.$loadBar.animate({opacity:0},{duration:500});
		}

		this.isSetup = true;

	// Aviator set up and we are just navigating between pages - don't need to re-add listeners (check this, I wrote this a long time ago?)
	}else{

		// LOAD PAGE CACHE
		var state = nav.getState();
		var cache = jcache.getCache(state.nextUrl);
		var $page = cache.$get(".js-body",false);
		this.$jsBody.html($page);

		var bodyClass = cache.$get("body",false).attr("class");
		var match = cache.raw.match(/<body[^>]*?class="([a-zA-Z0-9\-_]+)"[^>]*>/);
		var bodyClass = match ? match[1] : "";
		this.$body.attr("class",bodyClass);

		// scroll to top when navigating to new page
		this.$scrollElement.scrollTop(0);

		this.loader.complete();

	}

	// elements that need recognising after every page load (as they change)
	this.$main = this.$jsBody.find(".js-page");

	// Process images
	this.imageController = new ImageController();
	this.imageController.addListener("ready",Igloo.delegate(this, function(){
		onComplete();
	}));
	var imageCount = this.imageController.$process(this.$body);

	this.readMoreSetup();

	// Add all links to aviator
	//nav.addToLinks($("a:not(.no-auto-link)"));
	nav.addToLinks($("a"));
	if(this.$menu) this.$menu.removeClass('visible');

	return true;
};
BaseController.prototype.swap = function(onComplete){
	return true;
};
BaseController.prototype.on = function(onComplete){

	this.$body.css("visibility","visible");

	this.$menu 				= $(".js-menu");
	this.$menuButton 	= $(".js-menu-button");

	this.configBackgroundScroll();
	this.configMenuButton();
	this.configMenuItems();

	if(typeof(ga) !== "undefined"){ //needs checking
		if(this.hasDoneFirstPage){
			ga('send', 'pageview', nav.getState().nextUrl);
		}
		this.hasDoneFirstPage = true;
	}

	this.resizeDelegate = jstage.addListener("resize",Igloo.delegate(this, this.onResize));
	this.onResize();

	return true;
}
BaseController.prototype.isDevice = function(device){
	var isDeviceVisible = $("body").find("." + device).is(":visible");
	return isDeviceVisible;
}
BaseController.prototype.isMobile = function(){
	var isMobile = this.isDevice('mobile');
	return isMobile;
}
BaseController.prototype.off = function(onComplete){

	var nextCache = jcache.getCache( nav.getState().nextUrl );

	if(nextCache?.status !== "loaded"){
		this.loader.start();
	}

	// close any open popups on a full page change
	PopupForm.forceCloseAll();

	jstage.removeListener("resize",this.resizeDelegate);
}
BaseController.prototype.configMenuButton = function() {
	if(this.$menuButton) {
		this.$menuButton.off();
		this.$menuButton.on('click', Igloo.$d(this, function($this){
			this.$menu.toggleClass('visible');
			$this.find('.menu-icon').toggleClass('hide');
			$this.find('.close-icon').toggleClass('hide');
		}));
	}
}
BaseController.prototype.readMoreSetup = function() {
	const $readMoreButton = $('.js-read-more-button');
	if ($readMoreButton) {
		$readMoreButton.on('click', function () {
			const $readMoreContent = $(this).parent().find('.js-read-more-content');
			$readMoreContent.toggleClass('read-more-content-visible');
		});
	}
}
BaseController.prototype.configMenuItems = function() {
	const $menuItem = $('.js-menu').find('a');
	const that = this;

	// Remove previous event handlers to prevent
	// them from being added multiple times.
	$menuItem.off();

	$menuItem.on('click', function() {
		const currentMenuItemHref = $(this).attr('href');
		const currentPageHref = location.pathname;
		if (currentMenuItemHref === currentPageHref) {
			that.$menu.toggleClass('visible');
			$('.menu-icon').toggleClass('hide');
			$('.close-icon').toggleClass('hide');
		}
	});
}
BaseController.prototype.configBackgroundScroll = function() {
	if(this.scrollDelegate){
		$(window).off('scroll',this.scrollDelegate);
	}else{
		this.scrollDelegate = function() {
			const backgroundVerticalPosition = -window.scrollY/3;
			$('.bg-grid').css('background-position', `0 ${backgroundVerticalPosition}px`)
		};
	}


	$(window).on('scroll', this.scrollDelegate)
}
BaseController.prototype.onResize = function(){

	const navContainer = document.querySelector('.nav-container');
	const menu = document.querySelector('.menu');
	const menuContent = menu.querySelectorAll('.js-menu-content');
	const menuContentHeight = menuContent[0].clientHeight + menuContent[1].clientHeight + menuContent[2].clientHeight;
	console.log(menuContentHeight , window.innerHeight)
	if (menuContentHeight > window.innerHeight && window.innerWidth < 1000) {
		menu.classList.add('menu-scroll');
		navContainer.classList.add('scroll');
		navContainer.classList.add('js-custom-scrollbar');

	} else {
		menu.classList.remove('menu-scroll');
		navContainer.classList.remove('scroll');
		navContainer.classList.remove('js-custom-scrollbar');
	}
	
}